<!--  -->
<template>
  <el-tabs type="border-card" v-model="tabIndex">
    <el-tab-pane label="案件信息" name="caseInfo">
      <div>
        <el-steps align-center :active="statusList.length - 1">
          <el-step style="margin-top: 10px;" v-for="(item) in this.statusList" :key="item.caseStatus"
            :title="item.title" :description="item.description"></el-step>
        </el-steps>
      </div>
      <div class="body" style="overflow: auto">
        <div>
          <el-descriptions class="margin-top" title="案件基本信息" :column="3" border>
            <template slot="extra">
              <!-- <el-button type="primary" size="small">操作</el-button> -->
            </template>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label">立案案号</template>
              {{ caseInfo.registerCode }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label">调解案号</template>
              {{ caseInfo.mediationCode }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label">执行案号</template>
              {{ caseInfo.exeCode }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 批次号 </template>
              {{ caseInfo.batchId }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 立案案由 </template>
              {{ caseInfo.cause }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 法院名称 </template>
              {{ caseInfo.courtName }}
              <!-- <el-tag size="small">学校</el-tag> -->
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 标的 </template>
              {{ caseInfo.underlyingAmount }}
            </el-descriptions-item>

            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 案件状态 </template>
              {{ caseInfo.caseStatus }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 委托时间 </template>
              <span style="">
                {{ caseInfo.entrustmentDate }}
              </span>
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 提交法院日期 </template>
              <span style="">
                {{ caseInfo.courtSubDate }}
              </span>
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 立案日期 </template>
              {{ caseInfo.filingDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 调解成功日期 </template>
              {{ caseInfo.mediationSuccessDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 开庭日期 </template>
              {{ caseInfo.trialDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 审判法官 </template>
              {{ caseInfo.undertakeJudge }} </el-descriptions-item>>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 判决生效日期 </template>
              {{ caseInfo.judgmentEffDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 执行申请日期 </template>
              {{ caseInfo.executionDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 执行立案日期 </template>
              {{ caseInfo.exeFilingDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 案件完成日期 </template>
              {{ caseInfo.caseCompleDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 律师费 </template>
              {{ caseInfo.lawyerFee }}
            </el-descriptions-item>

            <!-- <el-descriptions-item span="3" labelStyle="width:7rem">
              <template slot="label"> 撤诉申请日期</template>
              {{ caseInfo.dropLawsuitDate }}
            </el-descriptions-item> -->
            <el-descriptions-item span="1" labelStyle="width:7rem">
              <template slot="label"> 撤诉裁定日期</template>
              {{ caseInfo.dropLawsuitRulingDate }}
            </el-descriptions-item>
            <el-descriptions-item span="3" labelStyle="width:7rem">
              <template slot="label"> 撤诉原因 </template>
              {{ caseInfo.dropLawsuitReason }}
            </el-descriptions-item>

            <el-descriptions-item span="1" labelStyle="width:7rem">
              <template slot="label"> 退案日期</template>
              {{ caseInfo.withdrawalDate }}
            </el-descriptions-item>
            <el-descriptions-item span="3" labelStyle="width:7rem">
              <template slot="label"> 退案原因 </template>
              {{ caseInfo.withdrawalReason }}
            </el-descriptions-item>
            <el-descriptions-item span="1" labelStyle="width:7rem">
              <template slot="label"> 案件受理费 </template>
              {{ caseInfo.caseFilingFee }}
            </el-descriptions-item>
            <el-descriptions-item span="1" labelStyle="width:7rem">
              <template slot="label"> 财产保全费 </template>
              {{ caseInfo.propertyPreservationFee }}
            </el-descriptions-item>
            <el-descriptions-item span="1" labelStyle="width:7rem">
              <template slot="label"> 公告费 </template>
              {{ caseInfo.announcementFee }}
            </el-descriptions-item>
            <el-descriptions-item span="3" labelStyle="width:7rem">
              <template slot="label"> 执行案律师 </template>
              {{ caseInfo.executingLawyer }}
            </el-descriptions-item>
            <el-descriptions-item span="3" labelStyle="width:7rem">
              <template slot="label"> 诉讼请求 </template>
              {{ caseInfo.claim }}
            </el-descriptions-item>
            <el-descriptions-item span="3" labelStyle="width:7rem">
              <template slot="label"> 事实与理由 </template>
              {{ caseInfo.truth }}
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 当事人信息 -->
        <div v-for="item in caseInfo.partyList" :key="item.id + '原告'">
          <el-descriptions v-if="item.litigationStatus == '原告'" class="margin-top" :title="'原告 ( ' + item.name + ' ) '"
            :column="3" border>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 当事人类型 </template>
              {{ item.partiesType }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 诉讼地位 </template>
              {{ item.litigationStatus }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 名字/公司 </template>
              {{ item.name }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 社会统一信用代码 </template>
              {{ item.idCard }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 法定代表人 </template>
              {{ item.legalRepresentative }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 负责人身份证 </template>
              {{ item.legalRepresentativeIdCard }}
            </el-descriptions-item>

            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 职位 </template>
              {{ item.post }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 手机号码 </template>
              {{ item.phone }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 户籍地/公司所在地 </template>
              {{ item.address }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 送达地址 </template>
              {{ item.serviceAddress }}
            </el-descriptions-item>
            <el-descriptions-item span="1" labelStyle="width:7rem">
              <template slot="label"> 邮箱 </template>
              {{ item.email }}
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <div v-for="item in caseInfo.partyList" :key="item.id + ''">
          <el-descriptions class="margin-top" v-if="item.litigationStatus == '被告'" :title="'被告 ( ' + item.name + ' )'"
            :column="3" border>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 当事人类型 </template>
              {{ item.partiesType }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 诉讼地位 </template>
              {{ item.litigationStatus }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 名字/公司 </template>
              {{ item.name }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 公民身份号码 </template>
              {{ item.idCard }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 性别 </template>
              {{ item.sex }}
            </el-descriptions-item>

            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 出生日期 </template>
              {{ item.birthday }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 民族 </template>
              {{ item.nation }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 手机号码 </template>
              {{ item.phone }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 户籍地 </template>
              {{ item.address }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 送达地址 </template>
              {{ item.serviceAddress }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 约定送达地址 </template>
              {{ item.agreedDeliveryAddress }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 邮箱/客户号 </template>
              {{ item.email }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 还款责任 </template>
              {{ item.responsibility }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 被告关系 </template>
              {{ item.defRelationship }}
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <div v-for="item in caseInfo.czCaseAgentList" :key="item.id + '原告代理'">
          <el-descriptions v-if="item.agentPosition == '原告'" class="margin-top"
            :title="'原告代理人 ( ' + item.agentName + ' )'" :column="3" border>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 第一代理人类型 </template>
              {{ item.agentType }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 诉讼代理人名 </template>
              {{ item.agentName }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 代理人性别 </template>
              {{ item.sex }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 身份证号 </template>
              {{ item.idCard }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 手机号 </template>
              {{ item.phone }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 地址 </template>
              {{ item.address }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 律师执业证 </template>
              {{ item.lawyerLicenseNo }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 诉讼代理人所在律所名称 </template>
              {{ item.lawfirmName }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 微信号 </template>
              {{ item.wechat }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 邮箱 </template>
              {{ item.email }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 庭审是否到场 </template>
              {{ item.isPresent == 0 ? "否" : "是" }}
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <div v-for="item in caseInfo.czCaseAgentList" :key="item.id">
          <el-descriptions v-if="item.agentPosition == '被告'" class="margin-top"
            :title="'被告代理人 ( ' + item.agentName + ' )'" :column="3" border>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 第一代理人类型 </template>
              {{ item.agentType }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 诉讼代理人名 </template>
              {{ item.agentName }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 身份证号 </template>
              {{ item.idCard }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 手机号 </template>
              {{ item.phone }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 地址 </template>
              {{ item.address }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 律师执业证 </template>
              {{ item.lawyerLicenseNo }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 诉讼代理人所在律所名称 </template>
              {{ item.lawfirmName }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 庭审是否到场 </template>
              {{ item.isPresent }}
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 信用卡信息 -->
        <div v-for="item in caseInfo.cardInfoList" :key="item.id">
          <el-descriptions class="margin-top" :title="'信用卡 ( ' + item.cardNumber + ' )'" :column="3" border>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 账号 </template>
              {{ item.accountNumber }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 开户机构 </template>
              {{ item.acceptingAuthority }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 签署协议名称 </template>
              {{ item.signingName }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 信用卡号 </template>
              {{ item.cardNumber }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 产品名称 </template>
              {{ item.productName }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 申请日期 </template>
              {{ item.applicationDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 开户日期 </template>
              {{ item.openingDate }}
            </el-descriptions-item>

            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 核销日期 </template>
              {{ item.accountDestroyDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 核销截止日期 </template>
              {{ item.accountDestroyEndDate }}
            </el-descriptions-item>

            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 本金 </template>
              {{ item.principal }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 本金截止日 </template>
              {{ item.principalDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 欠款总额 </template>
              {{ item.totalDebt }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 核销利息 </template>
              {{ item.hexiaoInterest }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 利息 </template>
              {{ item.interest }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 利息截止日期 </template>
              {{ item.deadlineDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 分期手续费 </template>
              {{ item.serviceCharge }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 分期手续费截止日期 </template>
              {{ item.serviceChargeEndDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 违约金 </template>
              {{ item.liquidatedDamages }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 违约金截止日期 </template>
              {{ item.liqDamagesEndDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 分期通手续费 </template>
              {{ item.serviceChargeTwo }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 分期通手续费截止日期 </template>
              {{ item.serviceChargeTwoEndDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 其他费用 </template>
              {{ item.otherExpenses }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 其他费用说明 </template>
              {{ item.otherDescription }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 其他费用截止日期 </template>
              {{ item.otherDescriptionEndDate }}
            </el-descriptions-item>

            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 其他费用2 </template>
              {{ item.otherExpenses2 }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 其他费用2说明 </template>
              {{ item.otherDescription2 }}
            </el-descriptions-item>

            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 其他费用2截止日期 </template>
              {{ item.otherDescription2EndDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 逾期日期 </template>
              {{ item.overdueDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 流水截止日 </template>
              {{ item.cutOffDate }}
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 抵押物信息 -->
        <div v-for="item in caseInfo.czEvidence" :key="item.id">
          <el-descriptions class="margin-top" :title="'抵押物 ( ' + item.evidenceName + ' )'" :column="3" border>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 抵押物名称 </template>
              {{ item.evidenceName }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 抵押物类型 </template>
              {{ item.evidenceType }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 抵押物编号 </template>
              {{ item.evidenceNum }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 车辆识别代号/车架号 </template>
              {{ item.vin }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 抵押物登记时间 </template>
              {{ item.registrationDate }}
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <div v-for="item in caseInfo.czInstallment" :key="item.id">
          <!--v-if="caseInfo.czInstallment.length != 0" -->
          <el-descriptions class="margin-top" title="分期信息" :column="3" border>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 卡号 </template>
              {{ item.cardNumber }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 分期类型 </template>
              {{ item.installmentType }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 分期协议名称 </template>
              {{ item.stagesScheme }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 协议签署时间 </template>
              {{ item.agreementDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 放款日期 </template>
              {{ item.loanDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 借款金额 </template>
              {{ item.borrowingSum }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 借款总手续费 </template>
              {{ item.borrowingChargeSum }}
            </el-descriptions-item>

            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 分期期数 </template>
              {{ item.installmentSum }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 手续费率 </template>
              {{ item.chargeRate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 还款日 </template>
              {{ item.billDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 还款金额 </template>
              {{ item.billMoney }}
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <!-- 贷款要素 -->
        <div v-if="caseInfo.czFinancialContract != undefined">
          <el-descriptions class="margin-top" :title="'贷款要素'" :column="3" border>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 合同签订日期 </template>
              {{ caseInfo.czFinancialContract.contractAwardDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 合同名称 </template>
              {{ caseInfo.czFinancialContract.contractName }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 合同编号 </template>
              {{ caseInfo.czFinancialContract.contractNum }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 到期日期 </template>
              {{ caseInfo.czFinancialContract.expiryDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 授信额度 </template>
              {{ caseInfo.czFinancialContract.creditLine }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 借款期限起始日期 </template>
              {{ caseInfo.czFinancialContract.loanStartDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 借款期限截至日期 </template>
              {{ caseInfo.czFinancialContract.loanEndDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 单笔借款期限（月） </template>
              {{ caseInfo.czFinancialContract.loanTerm }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 借款用途 </template>
              {{ caseInfo.czFinancialContract.loanPurpose }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 还款方式 </template>
              {{ caseInfo.czFinancialContract.paymentMethod }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 本金到期日期 </template>
              {{ caseInfo.czFinancialContract.principalDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 逾期日期 </template>
              {{ caseInfo.czFinancialContract.overdueDate }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 本金 </template>
              {{ caseInfo.czFinancialContract.principal }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 利息 </template>
              {{ caseInfo.czFinancialContract.interest }}
            </el-descriptions-item>
            <el-descriptions-item labelStyle="width:7rem">
              <template slot="label"> 利息截止日期 </template>
              {{ caseInfo.czFinancialContract.deadlineDate }}
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <div v-if="caseInfo.czFinancialDetails != undefined && caseInfo.czFinancialDetails.length > 0"
          style="margin-top: 20px">
          <div style="
              width: 100%;
              height: 40px;
              line-height: 40px;
              text-align: center;
              background-color: #54a0f4;
              color: white;
              font-size: 16px;
              font-weight: 600;
            ">
            <span>贷款详情信息</span>
          </div>
          <el-table :data="caseInfo.czFinancialDetails" border height="300" :summary-method="getSummaries" show-summary
            style="width: 100%; margin-top: 20px">
            <el-table-column align="center" label="序号" type="index" width="80"></el-table-column>
            <el-table-column align="center" prop="bankName" label="收款银行">
            </el-table-column>
            <el-table-column align="center" prop="bankCard" label="收款卡号">
            </el-table-column>
            <el-table-column align="center" prop="contractCode" label="贷款合约号">
            </el-table-column>
            <el-table-column align="center" prop="amount" label="借款金额（元）">
            </el-table-column>
            <el-table-column align="center" prop="borrowDate" label="借款日期">
            </el-table-column>
            <el-table-column align="center" prop="expiryDate" label="到期日期">
            </el-table-column>
            <el-table-column align="center" prop="payPrincipal" label="已还本金（元）">
            </el-table-column>
            <el-table-column align="center" prop="payInterest" label="已还利息（元）">
            </el-table-column>
            <el-table-column align="center" prop="principal" label="应还本金（元）">
            </el-table-column>
            <el-table-column align="center" prop="interest" label="应还利息（元）">
            </el-table-column>
            
            <el-table-column align="center" prop="principalAndInterest" label="应还本息（元）">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-tab-pane>
    <el-tab-pane name="mediateData" label="调解方案"
      v-if="cMediateData != null && cMediateData != {} && cMediateData.length > 0">
      <el-descriptions v-for="item in cMediateData" :key="item.id" :title="'(' + item.cardNumber + ') 调解方案'"
        direction="vertical" :column="4" border>
        <el-descriptions-item label="卡号">{{ item.cardNumber }}</el-descriptions-item>
        <el-descriptions-item label="方案开始日期">{{
          item.schemeStartDate
        }}</el-descriptions-item>
        <el-descriptions-item label="方案结束日期">{{
          item.schemeEndDate
        }}</el-descriptions-item>
        <el-descriptions-item label="每月还款金额">
          {{ item.monthlyAmount }}
        </el-descriptions-item>
        <el-descriptions-item label="首期还款金额">{{
          item.fristIssueAmount
        }}</el-descriptions-item>
        <el-descriptions-item label="最后一期还款金额">{{
          item.lastIssueAmount
        }}</el-descriptions-item>
        <el-descriptions-item label="每月还款日">{{ item.mouthlyPayDate }}号</el-descriptions-item>
        <el-descriptions-item label="分期数">{{
          item.installmentNum
        }}</el-descriptions-item>
        <el-descriptions-item label="标的" span="1">{{
          item.underlyingAmount
        }}</el-descriptions-item>
        <el-descriptions-item label="" span="3"></el-descriptions-item>
      </el-descriptions>
    </el-tab-pane>
    <el-tab-pane name="exePlan" label="执行方案" v-if="cExePlan != undefined">
      <el-descriptions class="margin-top" v-for="item in cExePlan" :key="item.id" title="执行方案" direction="vertical"
        :column="4" border>
        <el-descriptions-item label="执行案号" span="1" labelStyle="width:7rem">{{
          item.exeCode
        }}</el-descriptions-item>
        <el-descriptions-item label="执行法官" span="1" labelStyle="width:7rem">{{
          item.exeUndertakeJudge
        }}</el-descriptions-item>
        <el-descriptions-item label="执行立案时间" span="1" labelStyle="width:7rem">{{
          item.exeFilingDate
        }}</el-descriptions-item>
        <el-descriptions-item label="卡号" span="1" labelStyle="width:7rem">{{ item.cardNumber }}</el-descriptions-item>
        <el-descriptions-item label="本金" span="1" labelStyle="width:7rem">{{ item.principal }}</el-descriptions-item>
        <el-descriptions-item label="利息" span="1" labelStyle="width:7rem">{{ item.interest }}</el-descriptions-item>
        <el-descriptions-item label="违约金" span="1" labelStyle="width:7rem">{{
          item.liquidatedDamages
        }}</el-descriptions-item>
        <el-descriptions-item label="分期手续费" span="1">
          {{ item.serviceCharge }}
        </el-descriptions-item>
        <el-descriptions-item label="其他费用" span="1">{{
          item.otherExpenses
        }}</el-descriptions-item>
        <el-descriptions-item label="其他费用名称" span="1">{{
          item.otherExpenseName
        }}</el-descriptions-item>
        <el-descriptions-item label="其他费用2" span="1">{{
          item.otherExpenses2
        }}</el-descriptions-item>
        <el-descriptions-item label="其他费用2名称" span="1">{{
          item.otherExpense2Name
        }}</el-descriptions-item>
        <el-descriptions-item label="标的" span="1">{{
          item.underlyingAmount
        }}</el-descriptions-item>

        <el-descriptions-item label="依据文号" span="1">
          {{ item.referenceNumber }}
        </el-descriptions-item>

        <el-descriptions-item label="执行依据日期" span="1">
          {{ item.referenceDate }}
        </el-descriptions-item>
        <el-descriptions-item label="已还金额" span="1">
          {{ item.repaidAmount }}
        </el-descriptions-item>

        <el-descriptions-item label="执行依据主文" span="4">
          {{ item.operativePart }}
        </el-descriptions-item>

      </el-descriptions>
    </el-tab-pane>
    <el-tab-pane label="档案资料" v-if="caseFileShow" name="caseFileTab">
      <el-card class="box-card" v-for="item in caseFile" :key="item.id">
        <div slot="header" class="clearfix">
          <span v-if="renameVis == false || changeFileId != item.id">{{ item.fileName }}</span>
          <span>
            <el-input style="width:200px" v-model="item.fileName"
              v-if="renameVis && changeFileId == item.id"></el-input>
            <el-button style="margin-left: 10px;" size="small" type="primary"
              v-if="renameVis && changeFileId == item.id" @click="renameFile(item)">确定</el-button></span>
          <el-button @click="rename(item)" style="float: right; padding: 3px 20px" type="text">重命名</el-button>
          <el-button @click="previewFile(item.id)" style="float: right; padding: 3px 20px" type="text">预览</el-button>
          <el-button v-permission:function="['czCaseInfoManager_upload_download']" @click="downCaseUploadFile(item.id)"
            style="float: right; padding: 3px 0" type="text">下载</el-button>
          <el-button v-permission:function="['czCaseInfoManager_upload_delete']" @click="deleteCaseUploadFile(item.id)"
            style="float: right; padding: 3px 10px" type="text">删除</el-button>
        </div>
      </el-card>
    </el-tab-pane>
    <el-tab-pane label="案件状态日志" v-permission:function="['czCaseInfoManager_case_status_log']">
      <el-table :key='tableKey' :data="caseStatusLogList" size="small" stripe highlight-current-row style="width: 100%">
        <el-table-column align="center" label="id" width="65">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>
        <el-table-column width="150px" align="center" label="原状态"><template slot-scope="scope">
            <span>
              {{ scope.row.originalStatus }}</span>
          </template>
        </el-table-column>
        <el-table-column width="150px" align="center" label="现状态"><template slot-scope="scope">
            <span>
              {{ scope.row.currentStatus }}</span>
          </template>

        </el-table-column>
        <!-- <el-table-column width="100px" align="center" label="实体"><template slot-scope="scope">
            <span>
              {{ scope.row.originalObject }}</span>
          </template>

        </el-table-column> -->
        <el-table-column width="150px" align="center" label="操作时间"><template slot-scope="scope">
            <span>
              {{ scope.row.createTime }}</span>
          </template>

        </el-table-column>
        <el-table-column width="150px" align="center" label="操作人ID"><template slot-scope="scope">
            <span>
              {{ scope.row.converter }}</span>
          </template>

        </el-table-column>

      </el-table>
    </el-tab-pane>


    <!-- 状态日志 -->


    <!-- <el-dialog title="修改文件名" :visible.sync="renameVis" width="30%">
      <el-input v-model="fileName" v-if="renameVis"></el-input><el-button v-if="renameVis"
        @click="renameFile()">确定</el-button>
      <span slot="footer" class="dialog-footer">
        <el-button @click="renameVis = false">取 消</el-button>
        <el-button type="primary" @click="renameFile()">确 定</el-button>
      </span>
    </el-dialog> -->

  </el-tabs>
</template>
<style scoped>
@import "../../../assets/style/CaseInfo/caseInfo.css";
</style>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { getCastAllInfo } from "@/api/czManager/register/index";
import {
  getCaseUploadFile,
  deleteCaseUploadFile,
  previewUrl,
  caseStatusList
} from "@/api/czManager/czCaseInfo/index";
import { downLoadFile } from "@/plugin/axios";
import {
  putObj
} from "@/api/czManager/fileInfo/index";
import {
  getCaseLog
} from '@/api/admin/gateLog/index'
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("d2admin/user", ["info"]),
  },
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["caseId"],
  data() {
    //这里存放数据
    return {
      caseInfo: {
        // czInstallment:[]
      },
      tabIndex: "caseInfo",
      cExePlan: [],
      cMediateData: [],
      caseFile: [],
      caseFileShow: false,
      statusList: [],
      logList: [],
      fileName: '',
      czCaeeFile: { id: '', fileName: '' },
      renameVis: false,
      changeFileId: '',
      caseStatusLogList: []
    };
  },

  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {

    previewFile(id) {
      previewUrl(id).then(res => {
        window.open(res);
      })
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 1) {
          sums[index] = "  ";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += " 元";
        } else {
          sums[index] = "  ";
        }
      });

      return sums;
    },
    getPreviewData() {
      var that = this;
      console.log(that.caseId);
      this.tabIndex = "caseInfo";
      getCastAllInfo({ caseId: that.caseId }).then((res) => {
        this.caseInfo = res;
        this.getStatus(this.caseInfo)
        if (res.czExecutes != null && res.czExecutes != undefined && res.czExecutes.length != 0) {
          this.cExePlan = res.czExecutes;
        } else {
          this.cExePlan = undefined;
        }
        if (
          res.czMediates != null &&
          res.czMediates != undefined &&
          res.czMediates != {}
        ) {
          this.cMediateData = res.czMediates;
        } else {
          this.cMediateData = undefined;
        }
      });
      getCaseUploadFile(this.caseId).then((res) => {
        if (res != [] && res.length > 0) {
          this.caseFileShow = true;
          this.caseFile = res;
        } else {
          this.caseFileShow = false;
        }
      });
    },
    deleteCaseUploadFile(id) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        deleteCaseUploadFile(id).then((res) => {
          if (res.statusCode == 2000) {
            this.$message({ message: "删除成功", type: "success" });
          }
          getCaseUploadFile(this.caseId).then((res) => {
            if (res != [] && res.length > 0) {
              this.caseFileShow = true;
              this.caseFile = res;
            } else {
              this.caseFileShow = false;
              this.getPreviewData();
            }
          });
        });
      });
    },
    getLogList() {
      getCaseLog(this.caseId).then(res => {
        this.logList = res
      })
    },
    getStatusList() {
      caseStatusList(this.caseId).then(res => {
        this.caseStatusLogList = res
      })
    },
    downCaseUploadFile(id) {
      downLoadFile(
        this,
        {
          isValidate: true,
          method: "get",
          url: "/api/case/czCaseFiles/downloadFile/" + id,
          fileNum: 0,
        },
        (req) => {
          return req;
        }
      );
      return;
    },

    rename(item) {
      this.renameVis = true;
      this.changeFileId = item.id
    },

    renameFile(item) {
      putObj(item.id, item).then(res => {
        this.renameVis = false;
        this.$message({ message: "重命名成功", type: "success" });
        this.getPreviewData();
        this.tabIndex = 'caseFileTab'
      })
    },
    getStatus(caseInfo) {
      if (caseInfo.caseStatus == '新收案件') {
        this.statusList = [{ title: '新收案件', description: caseInfo.entrustmentDate }, { title: '待处置', description: '' }]
      }
      if (caseInfo.caseStatus == '处置中') {
        this.statusList = [{ title: '新收案件', description: caseInfo.entrustmentDate }, { title: '处置中', description: caseInfo.editTime }, { title: '待提交法院', description: '' }]
      }
      if (caseInfo.caseStatus == '提交法院' || caseInfo.caseStatus == '提交诉讼服务网') {
        this.statusList = [{ title: '新收案件', description: caseInfo.entrustmentDate }, { title: '处置中', description: caseInfo.editTime }, { title: '提交法院', description: "" + caseInfo.courtSubDate }, { title: '待立案', description: '' }]
      }
      if (caseInfo.caseStatus == '待缴费' || caseInfo.caseStatus == '缴费中') {
        this.statusList = [{ title: '新收案件', description: caseInfo.entrustmentDate }, { title: '处置中', description: caseInfo.editTime }, { title: '提交法院', description: "" + caseInfo.courtSubDate }, { title: '已立案', description: caseInfo.filingDate }, { title: '缴费中', description: "截止日期：" + caseInfo.paymentDate }]
      }
      if (caseInfo.caseStatus == '待开庭排期') {
        this.statusList = [{ title: '新收案件', description: caseInfo.entrustmentDate }, { title: '处置中', description: caseInfo.editTime }, { title: '提交法院', description: "" + caseInfo.courtSubDate }, { title: '已立案', description: caseInfo.filingDate }, { title: '已缴费', description: '' }, { title: '待排期开庭', description: '' }]
      }
      if (caseInfo.caseStatus == '调档中' || caseInfo.caseStatus == '待开庭') {
        this.statusList = [{ title: '新收案件', description: caseInfo.entrustmentDate }, { title: '处置中', description: caseInfo.editTime }, { title: '提交法院', description: "" + caseInfo.courtSubDate }, { title: '已立案', description: caseInfo.filingDate }, { title: '已缴费', description: '' }, { title: '已排期开庭', description: '开庭日期:' + caseInfo.trialDate + ",承办法官:" + caseInfo.undertakeJudge }, { title: '待开庭', description: '' }]
      }
      if (caseInfo.caseStatus == '判决中') {
        this.statusList = [{ title: '新收案件', description: caseInfo.entrustmentDate }, { title: '处置中', description: caseInfo.editTime }, { title: '提交法院', description: "" + caseInfo.courtSubDate }, { title: '已立案', description: caseInfo.filingDate }, { title: '已缴费', description: '' }, { title: '已开庭', description: '开庭日期:' + caseInfo.trialDate + ",承办法官:" + caseInfo.undertakeJudge }, { title: '等待判决', description: '' }]
      }
      if (caseInfo.caseStatus == '判决生效中') {
        this.statusList = [{ title: '新收案件', description: caseInfo.entrustmentDate }, { title: '处置中', description: caseInfo.editTime }, { title: '提交法院', description: "" + caseInfo.courtSubDate }, { title: '已立案', description: caseInfo.filingDate }, { title: '已缴费', description: '' }, { title: '已开庭', description: '开庭日期:' + caseInfo.trialDate + ",承办法官:" + caseInfo.undertakeJudge }, { title: '已判决', description: caseInfo.judgmentEffDate }, { title: '待结案', description: '' }]
      }
      if (caseInfo.caseStatus == '待执行') {
        if (caseInfo.czMediates != [] && caseInfo.czMediates != undefined) {
          this.statusList = [{ title: '新收案件', description: caseInfo.entrustmentDate }, { title: '处置中', description: caseInfo.editTime }, { title: '提交法院', description: "" + caseInfo.courtSubDate }, { title: '已立案', description: caseInfo.filingDate }, { title: '调解成功', description: '调解成功日期:' + caseInfo.mediationSuccessDate }, { title: '待执行', description: "" }]
        } else {
          this.statusList = [{ title: '新收案件', description: caseInfo.entrustmentDate }, { title: '处置中', description: caseInfo.editTime }, { title: '提交法院', description: "" + caseInfo.courtSubDate }, { title: '已立案', description: caseInfo.filingDate }, { title: '已缴费', description: '' }, { title: '已开庭', description: '开庭日期:' + caseInfo.trialDate + ",承办法官:" + caseInfo.undertakeJudge }, { title: '已判决', description: caseInfo.judgmentEffDate }, { title: '待执行', description: "" }]
        }
      }
      if (caseInfo.caseStatus == '执行中') {
        this.statusList = [{ title: '新收案件', description: caseInfo.entrustmentDate }, { title: '处置中', description: caseInfo.editTime }, { title: '提交法院', description: "" + caseInfo.courtSubDate }, { title: '已立案', description: caseInfo.filingDate }, { title: '已缴费', description: '' }, { title: '已开庭', description: '开庭日期:' + caseInfo.trialDate + ",承办法官:" + caseInfo.undertakeJudge }, { title: '已判决', description: caseInfo.judgmentEffDate }, { title: '执行中', description: "执行立案时间：" + caseInfo.exeFilingDate }]
      }
      if (caseInfo.caseStatus == '调解中') {
        this.statusList = [{ title: '新收案件', description: caseInfo.entrustmentDate }, { title: '处置中', description: caseInfo.editTime }, { title: '提交法院', description: "" + caseInfo.courtSubDate }, { title: '调解中', description: "" }]
      }
      if (caseInfo.caseStatus == '调解成功') {
        this.statusList = [{ title: '新收案件', description: caseInfo.entrustmentDate }, { title: '处置中', description: caseInfo.editTime }, { title: '提交法院', description: "" + caseInfo.courtSubDate }, { title: '调解成功', description: "调解成功时间：" + caseInfo.mediationSuccessDate }, { title: '待出具调解书', description: "" }]
      }
      if (caseInfo.caseStatus == '调解方案履行中') {
        this.statusList = [{ title: '新收案件', description: caseInfo.entrustmentDate }, { title: '处置中', description: caseInfo.editTime }, { title: '提交法院', description: "" + caseInfo.courtSubDate }, { title: '调解成功', description: "调解成功时间：" + caseInfo.mediationSuccessDate }, { title: '已出具调解书', description: "" }, { title: '方案履行中', description: "" }]
      }
      if (caseInfo.caseStatus == '撤诉中') {
        this.statusList = [{ title: '新收案件', description: caseInfo.entrustmentDate }, { title: '处置中', description: caseInfo.editTime }, { title: '提交法院', description: "" + caseInfo.courtSubDate }, { title: '撤诉中', description: "申请撤诉日期：" + caseInfo.dropLawsuitDate }, { title: '待确认', description: "" }]
      }
      if (caseInfo.caseStatus == '已撤诉') {
        this.statusList = [{ title: '新收案件', description: caseInfo.entrustmentDate }, { title: '处置中', description: caseInfo.editTime }, { title: '提交法院', description: "" + caseInfo.courtSubDate }, { title: '撤诉中', description: "申请撤诉日期：" + caseInfo.dropLawsuitDate }, { title: '已撤诉', description: "撤诉日期：" + caseInfo.dropLawsuitRulingDate }]
      }
      if (caseInfo.caseStatus == '已完成') {
        this.statusList = [{ title: '新收案件', description: caseInfo.entrustmentDate }, { title: '处置中', description: caseInfo.editTime }, { title: '提交法院', description: "" + caseInfo.courtSubDate }, { title: '已立案', description: caseInfo.filingDate }, { title: '已缴费', description: '' }, { title: '已排期开庭', description: '开庭日期:' + caseInfo.trialDate + ",承办法官:" + caseInfo.undertakeJudge }, { title: '已开庭', description: '' }, { title: '已判决', description: caseInfo.judgmentEffDate }, { title: '已结案', description: caseInfo.caseCompleDate }]
      }
      if (caseInfo.caseStatus == '已退案') {
        this.statusList = [{ title: '新收案件', description: caseInfo.entrustmentDate }, { title: '已退案', description: "退案日期：" + caseInfo.withdrawalDate }]
      }
    }
  },



  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getPreviewData();
    this.getLogList();
    let username = this.$store.state.d2admin.permission.userName;
    if (username == "蓬莱管理员") {
      this.getStatusList();
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.margin-top {
  margin-top: 20px;
}

.body>>>.el-descriptions-item__content {
  width: 8rem !important;
  /* background-color: red; */
}
</style>
